import React, {useState} from 'react';
// material
import { Button, Card, CardContent, Grid, withStyles} from '@material-ui/core';
//styles
import styles from './avatar-card-styles';
//components
import Editor from '../../avatar-editor/avatar-editor-container';
import Avatar from '../../avatar/avatar-view';

const AvatarCardView = (props) => {
  const {classes, photoUrl, isLoading, toggleEdit ,setAvatar} = props;
  const [uploadImage, setUploadImage] = useState({
    image: '',
    showImageSizeWarning: false
  })
  const [croppedImage, setCroppedImage] = useState(null);

  const save = () => {
    if (uploadImage.image.data) {
      let avatar = uploadImage.image
      if (croppedImage !== null) {
        avatar.data = croppedImage
      }

      setAvatar(avatar);
    } else {
      toggleEdit();
    }
  };

  const handleImageUpload = async (e) => {
    if (!e.target.files.length)
      return;

    const size = e.target.files[0].size;
    const name = e.target.files[0].name;
    if (size > 4194304)
      return setUploadImage({ showImageSizeWarning: true });

    const fileData = await getBase64(e.target.files[0]);
    const file = {
      format: name.substr(name.lastIndexOf('.') + 1),
      data: fileData
    };

    setUploadImage({ image: file, showImageSizeWarning: false });
    handleChangedImage(fileData)
  };

  const handleChangedImage = (changedImage) => setCroppedImage(changedImage);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = () => resolve(window.btoa(reader.result));
      reader.onerror = error => reject(error);
    });
  };

  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item >Avatar</Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container>
            <Grid item xs={12} className={classes.avatarContainer}>
              <Grid
                container
                direction='column'
                justify='center'
                alignItems='center'
                spacing={2} >
                <Grid item xs={12} sm={12}>
                  {
                    uploadImage.image.data ?
                      <Editor
                        image={'data:image/png;base64,' + uploadImage.image.data}
                        onImageChange={handleChangedImage}
                        height={250}
                        width={250}
                        commitOnChangeOnly/> :
                      <Avatar src={photoUrl} alt={'photo'} className={classes.avatar} size={250} />
                  }
                </Grid>
                <Grid item xs={12} sm={12}>
                  <input
                    accept='image/jpeg'
                    style={{ display: 'none' }}
                    id='raised-button-file'
                    multiple
                    type='file'
                    onChange={handleImageUpload}
                  />
                  <label htmlFor='raised-button-file'>
                    <Button color={'primary'} size={'small'} aria-label={'small'} variant={'contained'} component='span'>
                      {uploadImage.image.data? 'Change' : 'Upload'}
                    </Button>
                  </label>
                </Grid>
                {
                  props.showImageSizeWarning &&
                  <Grid item xs={12} className={classes.textCenter + ' ' + classes.errorText}>
                    uploaded image must be less than 4MB
                  </Grid>
                }
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={2}>
                <Grid item>
                  <Button color={'primary'} size={'small'} variant={'contained'} onClick={save}>Save</Button>
                </Grid>
                <Grid item>
                  <Button color={'primary'} size={'small'} onClick={toggleEdit}>Cancel</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (AvatarCardView);